import { getShopifyInstallInviteDestination } from '@/flows/shopifyInstall';
export const INVITE_SUCCESS_SEARCH_PARAM = 'invite_success';

export const INVITE_SUCCESS_PARAMS_TO_CLEAR = [
  INVITE_SUCCESS_SEARCH_PARAM,
  'workspace_id',
  'workspaceId',
] as const;

export interface InviteSuccessReturnParams {
  success: boolean;
  workspaceId: string | null;
}

export const buildInviteSuccessAdminRoute = (workspaceId: string, currentSearch = ''): string => {
  const installDestination = getShopifyInstallInviteDestination(currentSearch, workspaceId);
  if (installDestination) return installDestination;
  const searchParams = new URLSearchParams();
  searchParams.set('workspace_id', workspaceId);
  searchParams.set(INVITE_SUCCESS_SEARCH_PARAM, 'true');
  return `/admin?${searchParams.toString()}`;
};

export const resolveInviteAcceptWorkspaceId = (response: unknown): string | null => {
  if (!response || typeof response !== 'object') {
    return null;
  }

  const directWorkspaceId = String(
    (response as { workspaceId?: unknown }).workspaceId || '',
  ).trim();
  if (directWorkspaceId) {
    return directWorkspaceId;
  }

  const data = (response as { data?: unknown }).data;
  if (!data || typeof data !== 'object') {
    return null;
  }

  const nestedWorkspaceId = String(
    (data as { workspaceId?: unknown }).workspaceId || '',
  ).trim();
  return nestedWorkspaceId || null;
};

export const readInviteSuccessReturnParams = (
  searchParams: URLSearchParams,
): InviteSuccessReturnParams => ({
  success: searchParams.get(INVITE_SUCCESS_SEARCH_PARAM) === 'true',
  workspaceId: searchParams.get('workspace_id')?.trim()
    || searchParams.get('workspaceId')?.trim()
    || null,
});

export const isInviteSuccessReturn = (searchParams: URLSearchParams): boolean => (
  readInviteSuccessReturnParams(searchParams).success
);

export const resolveInviteSuccessWorkspaceAction = (
  inviteSuccess: boolean,
  requestedWorkspaceId?: string | null,
  currentWorkspaceId?: string | null,
  isLoadingWorkspaces: boolean = false,
): 'wait' | 'continue' => {
  if (!inviteSuccess) {
    return 'continue';
  }

  if (isLoadingWorkspaces || !currentWorkspaceId) {
    return 'wait';
  }

  if (requestedWorkspaceId && requestedWorkspaceId !== currentWorkspaceId) {
    return 'wait';
  }

  return 'continue';
};
